<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <el-tabs type="border-card" v-model="pageLangCode">
        <el-tab-pane :name="langItem.langCode" :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.langMaps" :key="index">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Title </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.title'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.title" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Event Type </label>
                <div class="col-sm-4">
                  <div>
                    <el-select v-model="detailInfo.type" v-bind:placeholder="$t('message.PleaseSelect')">
                      <el-option v-for="item in typeObj" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.type == 2">
                <label class="col-sm-2 control-label">
                  Campaign Enroll Title
                </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.camEnrollTitle'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.camEnrollTitle" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.type == 2">
                <label class="col-sm-2 control-label">
                  Campaign Enroll Prompt Info
                </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.camEnrollProInfo'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.camEnrollProInfo" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.type == 2">
                <label class="col-sm-2 control-label"> Step 1 URL </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.stepUrl1'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.stepUrl1" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.type == 2">
                <label class="col-sm-2 control-label"> Step 2 URL</label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.stepUrl2'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.stepUrl2" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Event Category (for display)</label>
                <div class="col-sm-10">
                  <div>
                    <el-select v-model="detailInfo.categoryIds" multiple
                      v-bind:placeholder="$t('message.PleaseSelect')">
                      <el-option v-show="['11', '12', '13', '14', '15'].includes(item.categoryCode)"
                        v-for="item in categoryList" :key="item.categoryCode" :label="item.categoryNameEn"
                        :value="item.categoryCode">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">IDEAS Points </label>
                <div class="col-sm-10">
                  <div class="col-sm-3" style="padding: 0">
                    <label class="col-sm-7 control-label" style="padding: 7px 0 0">Innovation Score
                    </label>
                    <el-form-item prop="innovationScore" :rules="scoreRule">
                      <el-input :disabled="!scoreEditable" v-model="detailInfo.innovationScore" show-word-limit
                        class="col-sm-5"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-sm-3" style="padding: 0">
                    <label class="col-sm-7 control-label" style="padding: 7px 0 0">Discipline Score
                    </label>
                    <el-form-item prop="disciplineScore" :rules="scoreRule">
                      <el-input :disabled="!scoreEditable" v-model="detailInfo.disciplineScore" show-word-limit
                        class="col-sm-5"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-sm-3" style="padding: 0">
                    <label class="col-sm-7 control-label" style="padding: 7px 0 0">Exposure Score
                    </label>
                    <el-form-item prop="exposureScore" :rules="scoreRule">
                      <el-input :disabled="!scoreEditable" v-model="detailInfo.exposureScore" show-word-limit
                        class="col-sm-5"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-sm-3" style="padding: 0">
                    <label class="col-sm-7 control-label" style="padding: 7px 0 0">Adventure Score
                    </label>
                    <el-form-item prop="adventureScore" :rules="scoreRule">
                      <el-input :disabled="!scoreEditable" v-model="detailInfo.adventureScore" show-word-limit
                        class="col-sm-5"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-sm-2 offset-sm-10" style="text-align: right;padding-top: 5px;">
                    <el-button type="primary" @click="scoreEditable = !scoreEditable">
                      {{ scoreEditable ? 'Done' : 'Edit' }}
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Event District </label>
                <div class="col-sm-10">
                  <el-input v-model="langItem.districtName" disabled></el-input>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Picture / Video </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.lstEventImages'" :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <uploadVideoOrPicture :inputFileList="langItem.lstEventImages"
                      @changeList="hadnleChangeImages($event, index)"></uploadVideoOrPicture>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Schedule Time (Start)
                </label>
                <div class="col-sm-10">
                  <el-date-picker v-model="detailInfo.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Schedule Time (End)
                </label>
                <div class="col-sm-10">
                  <el-date-picker v-model="detailInfo.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Application Time (Start)
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="enrollStartTime" :rules="enrollStartTimeRule">
                    <el-date-picker :disabled="!scoreEditable" v-model="detailInfo.enrollStartTime" type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss" @change="validateApplicationDate">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Application Time (End)
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="enrollEndTime" :rules="enrollEndTimeRule">
                    <el-date-picker :disabled="!scoreEditable" v-model="detailInfo.enrollEndTime" type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss" @change="validateApplicationDate">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Event Date </label>
                <div class="col-sm-10">
                  <div class="col-sm-12" style="padding-bottom: 15px" v-for="(item, k) in detailInfo.eventDatetime"
                    :key="k">
                    <div class="col-sm-4">
                      <el-form-item :prop="'eventDatetime.' + k + '.date'" :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      }">
                        <el-date-picker v-model="item.date" type="date" value-format="yyyy-MM-dd">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div class="col-sm-3">
                      <el-form-item :prop="'eventDatetime.' + k + '.startTime'" :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      }">
                        <el-time-select v-model="item.startTime" :picker-options="{
                          start: '00:00',
                          step: '00:01',
                          end: '23:59',
                        }" placeholder="Start time">
                        </el-time-select>
                      </el-form-item>
                    </div>
                    <div class="col-sm-3">
                      <el-form-item :prop="'eventDatetime.' + k + '.endTime'" :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      }">
                        <el-time-select v-model="item.endTime" :picker-options="{
                          start: '00:00',
                          step: '00:01',
                          end: '23:59',
                        }" placeholder="End time">
                        </el-time-select>
                      </el-form-item>
                    </div>
                    <div class="col-sm-2">
                      <i class="el-icon-close pointer" v-if="!(k == 0 && detailInfo.eventDatetime.length == 1)"
                        @click="deleteObj(detailInfo.eventDatetime, k)" style="font-size: 20px; padding: 10px 0"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group margin-0">
                <label class="col-sm-2 control-label"> </label>
                <div class="col-sm-6">
                  <div @click="addEventDate(detailInfo.eventDatetime)" class="underline pointer">
                    Add
                  </div>
                </div>
              </div>
              <!-- TODO -->
              <div class="form-group" style="margin-bottom:40px !important;">
                <label class="col-sm-2 control-label"> Event Age Group </label>
                <div class="col-sm-10" style="display: flex;align-items: center;">
                  <el-form-item :prop="'ageFrom'" :rules="ageFormRule">
                    <el-input v-model.number="detailInfo.ageFrom" autocomplete="off" style="width: 150px;"></el-input>
                  </el-form-item>
                  <div style="margin:0 15px">to</div>
                  <el-form-item :prop="'ageEnd'" :rules="ageEndRule">
                    <el-input v-model.number="detailInfo.ageEnd" autocomplete="off" style="width: 150px;"></el-input>
                  </el-form-item>
                  <div style="margin-left:15px;">years of age</div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Location Info </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.address'" :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.address" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Description </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.description'" :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <ckeditor :editor="editor" @ready="onReady" v-model="langItem.description" :config="editorConfig">
                    </ckeditor>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">J Coins</label>
                <div class="col-sm-10">
                  <el-form-item prop="pointFlag" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input-number v-model="detailInfo.pointFlag" :min="0"></el-input-number>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Form Type </label>
                <div class="col-sm-4">
                  <div>
                    <el-select v-model="detailInfo.formType" clearable @change="changeFormType"
                      v-bind:placeholder="$t('message.PleaseSelect')">
                      <el-option v-for="item in formTypeObj" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.formType">
                <label class="col-sm-2 control-label"> Attachment 1 </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.eFormTitle'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.eFormTitle" maxlength="30" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group" v-if="detailInfo.formType && langItem.fileList.length > 1">
                <label class="col-sm-2 control-label">Attachment 2</label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.eForm2Title'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.eForm2Title" maxlength="30" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group" v-if="detailInfo.formType === 0">
                <label class="col-sm-2 control-label"> Form Link </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.formUrl'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.formUrl" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.formType == 1">
                <label class="col-sm-2 control-label"> Upload </label>
                <div class="col-sm-10">
                  <el-upload class="upload-demo" action="#" :http-request="uploadFile2" :auto-upload="true" :limit="2"
                    :file-list="langItem.fileList" :on-preview="previewEvent"
                    :on-remove="(file) => deleteFileEvent(file, index)" accept=".pdf, .PDF, .doc, .docx, .DOC, .DOCX"
                    :show-file-list="true">
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The
                      uploaded
                      file should not exceed 5MB</div>
                    <div style="display: flex;align-items: center;">
                      <el-button size="small">Select file</el-button>
                      <div style="margin-left:20px;"> (You can upload up to 2 attachments here)</div>
                    </div>


                  </el-upload>
                  <el-form-item :prop="'langMaps.' + index + '.formUrl'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input style="display: none" v-model="langItem.fileList" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Status </label>
                <div class="col-sm-4">
                  <el-form-item prop="status" :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-select v-model="detailInfo.status" disabled v-bind:placeholder="$t('message.PleaseSelect')">
                      <el-option v-for="item in statusObj" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button type="primary" @click="checkEvent()" :disabled="!(
                      !detailInfo.status ||
                      detailInfo.status == 3 ||
                      detailInfo.status == 4
                    )
                      " v-if="(checkPermission('EVENT_LIST_EDIT') &&
                        $route.query.id) ||
                        (checkPermission('EVENT_LIST_ADD') && !$route.query.id)
                      ">Save</el-button>
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import vuedraggable from "vuedraggable";
import config from "../config";
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import uploadVideoOrPicture from "../components/uploadVideoOrPicture/index";

export default {
  mixins: [config.globalMixin],
  data() {
    var validateAgeForm = (rule, value, callback) => {
      console.log("0000", this)
      console.log("111111", value, this.detailInfo.ageEnd, value >= this.detailInfo.ageEnd)
      if (value < 6 || value > 25) {
        callback(new Error('Input age range between 6 and 25'));
      } else if (value >= this.detailInfo.ageEnd) {
        callback(new Error('Age (To) must be equal or greater than Age (From)'));
      } else {
        callback();
      }
    }
    var validateAgeEnd = (rule, value, callback) => {
      if (value < 6 || value > 25) {
        callback(new Error('Input age range between 6 and 25'));
      } else if (value <= this.detailInfo.ageForm) {
        callback(new Error('Age (To) must be equal or greater than Age (From)'));
      } else {
        callback();
      }
    }

    const validateEnrollStartTime = (rule, value, callback) => {
      const { enrollStartTime, enrollEndTime } = this.detailInfo;
      if ((enrollStartTime && !enrollEndTime) || (!enrollStartTime && enrollEndTime)) {
        callback(new Error('The "Application Time" must either be filled in simultaneously or left blank simultaneously.'));
      } else if (enrollStartTime && enrollEndTime && new Date(enrollStartTime) >= new Date(enrollEndTime)) {
        callback(new Error('Application Time (Start) must be earlier than Application Time (End).'));
      } else {
        callback();
      }
    };
    // 校验IDEAS Points
    const validateScore = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(); // 允许为空
      } else if (!/^(0|[1-9]\d*)$/.test(value)) {
        callback(new Error('Input must be a positive integer.'));
      } else {
        callback();
      }
    };
    return {
      // TODO
      ageFormRule: [
        {
          required: false,
          message: this.$t('message.required'),
          trigger: 'blur',
        },
        {
          type: 'number',
          message: 'Age must be a number',
          trigger: 'blur'
        },
        { validator: validateAgeForm, trigger: 'blur' }
      ],
      ageEndRule: [
        {
          required: false,
          message: this.$t('message.required'),
          trigger: 'blur',
        },
        {
          type: 'number',
          message: 'Age must be a number',
          trigger: 'blur'
        },
        { validator: validateAgeEnd, trigger: 'blur' }
      ],
      enrollStartTimeRule: [{
        required: true,
        message: this.$t('message.required'),
        trigger: 'blur',
      },
      { validator: validateEnrollStartTime, trigger: 'change' }
      ],
      enrollEndTimeRule: [{
        required: true,
        message: this.$t('message.required'),
        trigger: 'blur',
      },
      { validator: validateEnrollStartTime, trigger: 'change' }
      ],
      scoreRule: [
        { validator: validateScore, trigger: 'blur' }
      ],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "Heading",
          "bold",
          "italic",
          "underline",
          "Link",
          "bulletedList",
          "numberedList",
        ],
        // The configuration of the editor.
      },
      detailInfo: {
        ageFrom: 6,
        ageEnd: 25,
        langMaps: [],
        status: 0,
        type: 1,
        startTime: "",
        endTime: "",
        categoryIds: "",
        formType: "",
        pointFlag: "",
        districtName: "",
        eventDatetime: [{ period: [] }],
        adventureScore: "",
        exposureScore: "",
        innovationScore: "",
        disciplineScore: "",
        // application的date
        enrollStartTime: "",
        enrollEndTime: "",
        // eventImageThumbnailUrl:'',
        // fileType:''
      },
      statusObj: [],
      typeObj: [],
      formTypeObj: [],
      categoryList: [],
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      disabled: false,
      picListCache: [],
      videoListCache: [{}],
      uploadErr: false,
      // 是否更改IDEAS Points
      scoreEditable: false,
      // 存初始detail值
      originalFields: {
        enrollStartTime: "",
        enrollEndTime: "",
        innovationScore: "",
        disciplineScore: "",
        exposureScore: "",
        adventureScore: ""
      },
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    detailInfo: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  created() {
    var obj = [];
    this.pageLangCode = this.$store.state.userInfo.language[0].langCode;
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        title: "",
        description: "",
        eFormTitle: "",
        eForm2Title: '',
        formUrl: "",
        form2Url: '',
        address: "",
        camEnrollTitle: "",
        camEnrollProInfo: "",
        stepUrl1: "",
        stepUrl2: "",
        fileList: [],
      });
    }
    this.$set(this.detailInfo, "langMaps", obj);
    this.init();
    this.getAllCategoryEvent();
  },
  mounted() { },
  methods: {
    validateApplicationDate() {
      this.$refs.detailInfo.validateField('enrollStartTime');
      this.$refs.detailInfo.validateField('enrollEndTime');
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    setObj: function () {
      this.statusObj = [
        {
          value: 0,
          label: "Draft",
        },
        {
          value: 1,
          label: "Pending approval",
        },
        {
          value: 2,
          label: "Pending Publish",
        },
        {
          value: 3,
          label: "Rejected",
        },
        {
          value: 4,
          label: "Suspended",
        },
        {
          value: 5,
          label: "Pending Suspend",
        },
        {
          value: 6,
          label: "Published",
        },
      ];
      this.typeObj = [
        {
          value: 1,
          label: "Normal",
        },
        {
          value: 2,
          label: "Campaign",
        },
        {
          value: 3,
          label: "Normal(NO enroll button)",
        },
        {
          value: 4,
          label: "Full",
        },
      ];
      this.formTypeObj = [
        {
          value: 0,
          label: "E-Form",
        },
        {
          value: 1,
          label: "Attachment",
        },
      ];
    },

    changeFormType() {
      this.detailInfo.langMaps.forEach((item) => {
        item.fileList = [];
        item.formUrl = "";
        item.form2Url = "";
      });
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.eventDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;

        if (data.data.result.categoryIds) {
          data.data.result.categoryIds =
            data.data.result.categoryIds.split(",");
        }
        if (!data.data.result.eventDatetime) {
          data.data.result.eventDatetime = [{ period: [] }];
        } else {
          data.data.result.eventDatetime = JSON.parse(
            data.data.result.eventDatetime
          );
        }
        if (!data.data.result.ageFrom) {
          data.data.result.ageFrom = 6
        }
        if (!data.data.result.ageEnd) {
          data.data.result.ageEnd = 25
        }

        data.data.result.langMaps.forEach(i => {
          i.fileList = []
          if (typeof i.description !== 'string') {
            i.description = ''
          }
          if (i.formUrl) {
            i.fileList.push({
              originalUrl: i.formUrl,
              name: i.formName || i.formUrl,
              url: i.showFormUrl,
            })
          }
          if (i.form2Url) {
            i.fileList.push({
              originalUrl: i.form2Url,
              name: i.form2Name || i.form2Url,
              url: i.showForm2Url,
            })
          }

        })

        delete data.data.result["userId"];
        this.$set(this, "detailInfo", data.data.result);
        // 存储初始值
        console.log(this.detailInfo, 'this.detailInfo');
        this.originalFields = {
          enrollStartTime: this.detailInfo.enrollStartTime,
          enrollEndTime: this.detailInfo.enrollEndTime,
          innovationScore: this.detailInfo.innovationScore,
          disciplineScore: this.detailInfo.disciplineScore,
          exposureScore: this.detailInfo.exposureScore,
          adventureScore: this.detailInfo.adventureScore
        };
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
      this.setObj();
    },
    checkEvent: function () {
      this.$refs["detailInfo"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    deleteObj: function (obj, index) {
      obj.splice(index, 1);
    },
    addEventDate(obj) {
      obj.push({
        date: "",
        startTime: "",
        endTime: "",
      });
    },
    async getAllCategoryEvent() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.getAllCategory;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "categoryList", data.data.result);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    async submit() {
      let obj = this.getAuthObj();
      for (var key in this.detailInfo) {
        obj[key] = this.detailInfo[key];
      }
      let changed = (
        obj.enrollStartTime !== this.originalFields.enrollStartTime ||
        obj.enrollEndTime !== this.originalFields.enrollEndTime ||
        obj.innovationScore !== this.originalFields.innovationScore ||
        obj.disciplineScore !== this.originalFields.disciplineScore ||
        obj.exposureScore !== this.originalFields.exposureScore ||
        obj.adventureScore !== this.originalFields.adventureScore
      );
      obj.updateCesCoreStatus = changed ? 1 : 0;

      var data;
      // if (this.$route.query.id) {
      obj.langMaps.forEach((item) => {
        item.lstEventImages.forEach((img, index) => {
          img.sortOrder = index;
          delete img["showImageUrl"];
        });
        if (item.fileList && item.fileList.length) {
          if (item.fileList[0]) {
            item.formUrl = item.fileList[0].originalUrl
            item.formName = item.fileList[0].name
            item.showFormUrl = item.fileList[0].url
          }
          if (item.fileList[1]) {
            item.form2Url = item.fileList[1].originalUrl
            item.form2Name = item.fileList[1].name
            item.showForm2Url = item.fileList[1].url
          }
          delete item['fileList']
        }
      });
      if (obj.categoryIds) {
        obj.categoryIds = obj.categoryIds.join(",");
      }
      obj.eventDatetime = JSON.stringify(obj.eventDatetime);
      obj.apiUrl = this.apiConfig.eventUpdate;
      // console.log(obj, 'obj');
      data = await this.$store.dispatch("apiEvent", obj);
      // } else {
      //   obj.apiUrl = this.apiConfig.eventCreate;
      //   data = await this.$store.dispatch("apiEvent", obj);
      // }
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.state.edit = false;
        this.$router.go(-1);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() { },

    async uploadFile2(params) {
      if (!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.getObject(this.detailInfo.langMaps, this.pageLangCode).fileList.push(
        {
          name: params.file.name,
          originalUrl: data.data.result.url,
          url: data.data.result.showUrl,
        },
      );
      if (this.getObject(this.detailInfo.langMaps, this.pageLangCode).formUrl) {
        this.getObject(this.detailInfo.langMaps, this.pageLangCode).form2Url =
          data.data.result.url;
      } else {
        this.getObject(this.detailInfo.langMaps, this.pageLangCode).formUrl =
          data.data.result.url;
      }

    },
    previewEvent(file) {
      // window.open(file.url);
    },
    deleteFileEvent(file, langIndex) {
      var index = "";
      for (var i = 0; i < this.detailInfo.langMaps[langIndex].fileList.length; i++) {
        if (this.detailInfo.langMaps[langIndex].fileList[i].name == file.name) {
          index = i;
        }
      }

      if (index == 0) {
        this.getObject(this.detailInfo.langMaps, this.pageLangCode).formUrl = this.getObject(this.detailInfo.langMaps, this.pageLangCode).form2Url;
        this.getObject(this.detailInfo.langMaps, this.pageLangCode).form2Url = "";
        this.getObject(this.detailInfo.langMaps, this.pageLangCode).eFormTitle = this.getObject(this.detailInfo.langMaps, this.pageLangCode).eForm2Title;
        this.getObject(this.detailInfo.langMaps, this.pageLangCode).eForm2Title = ''
      }
      if (index == 1) {
        this.getObject(this.detailInfo.langMaps, this.pageLangCode).form2Url = "";
        this.getObject(this.detailInfo.langMaps, this.pageLangCode).eForm2Title = ''
      }
      this.detailInfo.langMaps[langIndex].fileList.splice(index, 1);
      this.$forceUpdate()
    },
    hadnleChangeImages(resList, index) {
      this.detailInfo.langMaps[index].lstEventImages = resList
    },
    handleCheckUploadFileSize(file) {
      const sizeKB = file.size / 1024
      if (sizeKB > 5120) {
        this.uploadErr = true
        return false
      } else {
        this.uploadErr = false
        return true
      }
    }
  },
  components: { vuedraggable, uploadVideoOrPicture },
};
</script>